import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "searchInput", "sortField", "directionField"]

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, 300)
  }

  updateSort(event) {
    if (this.hasSortFieldTarget) {
      this.sortFieldTarget.value = event.currentTarget.dataset.sortColumn
    }

    if (this.hasDirectionFieldTarget) {
      this.directionFieldTarget.value = event.currentTarget.dataset.sortDirection
    }
  }
}
